import { render, staticRenderFns } from "./PickPatternCategory.vue?vue&type=template&id=0d98c6c0&scoped=true&"
import script from "./PickPatternCategory.vue?vue&type=script&lang=js&"
export * from "./PickPatternCategory.vue?vue&type=script&lang=js&"
import style0 from "./PickPatternCategory.vue?vue&type=style&index=0&id=0d98c6c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98c6c0",
  null
  
)

export default component.exports